// Platform overview (coordinator request, 14 October 2026). The text is docs/PLATFORM_OVERVIEW.md, bundled at build
// time, so the page and the document sent to the consortium never differ. The source is our own file in the
// repository, never user input, so rendering its HTML is safe.
import { marked } from 'marked';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import overview from '../../../../docs/PLATFORM_OVERVIEW.md?raw';

export function Guide() {
  const { t, i18n } = useTranslation();
  const html = useMemo(() => marked.parse(overview, { async: false }), []);
  return (
    <main className="guide">
      {!i18n.language.startsWith('en') && <p className="hint">{t('guide.english_only')}</p>}
      <article dangerouslySetInnerHTML={{ __html: html }} />
    </main>
  );
}
